import PageCreateUser from '../update';
export default PageCreateUser;
